<template>
    <div
        id="dashboard-slide"
        class="custom-slider splide mb-5">
        <div class="splide__track">
            <ul class="splide__list">
                <li class="splide__slide"
                    v-for="(dashboard, k) in arrDashboard"
                    :key="k"
                    @click="clickDashboard(dashboard)">
                    <div class="inner m-auto">
                        <img class="w-full h-auto" :src="dashboard.imageUrl" alt=""/>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
// library
import Splide from '@splidejs/splide'; //https://splidejs.com/
import Locale from "@/helper/locale/Locale.js";
// service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";
// mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import { useTracking } from "@/feature/TrackingFeature"
/**
 * @event onLoaded
 */
export default {
    name: "DashboardSlider",
    mixins: [ErrorApiMixin],
    props: {
        apiConfig: { type: String, required: true },
        modalController: { type: Object }
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function () {
        return {
            arrDashboard: [],
            slider: null,
        };
    },
    created: function() {
        this.tracking.event("privilege_page_list", "view_banner", "", "");
        this.getDashboard();
    },
    methods: {
        getDashboard: function() {
            let configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            let params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, this.apiConfig).subscribe((data) => {
                this.arrDashboard = data;
                this.setSlider();

                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },
        clickDashboard: function(dashboard) {
            this.tracking.event("privilege_page_list", "click_banner", "", "");
            if (dashboard.type == 'link') {
                window.open(dashboard.url, '_blank');
            } else if (dashboard.type == 'campaign' ) {
                this.$router.push('/campaign/'+dashboard.id)
            } else if (dashboard.type == 'cat') {
                this.$emit('categoryFromDashBoard', dashboard);
            }
        },
        setSlider: function() {
            if (this.arrDashboard.length == 0) return;

            this.$nextTick(() => {
                this.slider = new Splide('#dashboard-slide', {
                    type: 'slide',
                    autoplay: true,
                    arrows: false,
                    pagination: true,
                    // focus: 'center',
                    autoWidth: true,
                    perPage: 1,
                    perMove: 1,
                    start: 0,
                    rewind: true,
                }).mount();
                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex;
                });
            });
        },
    },
};
</script>
<style lang="scss">
@import "@/style/base/base.scss";
.custom-slider{
    .splide__slide {
        .inner {
            transform: scale(0.95);
            transition: all;
            transition-duration: 200ms;
        }

        display: inline-flex;
        vertical-align: middle;

        img {
            max-height: 180px;
            max-width: 310px;
            border-radius: 10px;
        }
    }

    .splide__pagination {
        position: relative;
        bottom: 3px;
        li{
            button{
                transform: unset;
                width: 5px;
                height: 5px;
                border: 1px solid #d0d0ce;
                background-color: #d0d0ce;
                border-radius: 100px;
            }
            .is-active{
                width: 14px;
                height: 5px;
                border: 1px solid #fe5000;
                background-color: #fe5000;
                border-radius: 100px;
                opacity: 1;
            }
        }
    }
}
</style>
